export interface LoginRequest {
  user_type: string;
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  account?: Record<string, unknown>;
  user?: Record<string, unknown>;
  domain?: Record<string, unknown>;
}

/** 将 API 返回的 user_type 收窄为登录态使用的联合类型 */
export function normalizeAuthUserType(
  value: string | undefined,
  fallback: 'account' | 'user' | 'admin'
): 'account' | 'user' | 'admin' {
  return value === 'account' || value === 'user' || value === 'admin' ? value : fallback;
}

export interface UserInfo {
  user_id: string;
  username: string;
  user_type: 'account' | 'user' | 'admin';
  account_id?: string;
  iam_user_id?: string;
  domain_id?: string;
  domain_alias?: string;
  account?: Record<string, unknown>;
  user?: Record<string, unknown>;
  domain?: Record<string, unknown>;
}
